"use strict";
'use es6'; // https://git.hubteam.com/HubSpotProtected/Merchandise/blob/master/MerchandiseCore/src/main/java/com/hubspot/merchandise/core/ChargeType.java

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NON_RECURRING = exports.RECURRING = void 0;
var RECURRING = 'RECURRING';
exports.RECURRING = RECURRING;
var NON_RECURRING = 'NON_RECURRING';
exports.NON_RECURRING = NON_RECURRING;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/ChargeTypes.js
// module id = 95
// module chunks = 5 6 7